export const RESET_PASSWORD_PATH = '/reset-password'

export const isResetPasswordPath = (pathname) =>
  String(pathname).replace(/\/$/, '').toLowerCase() === RESET_PASSWORD_PATH
